import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { LegendItem } from './legend-item';

@Component({
  selector: 'pcs-legend-item',
  templateUrl: './legend-item.component.html',
  styleUrls: ['./legend-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegendItemComponent  {
  @Input() legendItem: LegendItem;
}
